const animation = {
  v: "5.9.0",
  fr: 50,
  ip: 0,
  op: 112,
  w: 400,
  h: 400,
  nm: "spinnerLightXS",
  ddd: 0,
  assets: [],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 4,
      nm: "circle",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 10,
              s: [202, 200, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.833, y: 0.833 },
              o: { x: 0.333, y: 0.333 },
              t: 26,
              s: [202, 242, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 46,
              s: [202, 242, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            { t: 58, s: [202, 200, 0] },
          ],
          ix: 2,
          l: 2,
        },
        a: { a: 0, k: [2, 0, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 1,
                k: [
                  {
                    i: { x: 0.62, y: 1 },
                    o: { x: 0.85, y: 0 },
                    t: 0,
                    s: [
                      {
                        i: [
                          [-98.859, 0],
                          [0, -98.859],
                          [98.859, 0],
                          [0, 98.859],
                        ],
                        o: [
                          [98.859, 0],
                          [0, 98.859],
                          [-98.859, 0],
                          [0, -98.859],
                        ],
                        v: [
                          [0, -179],
                          [179, 0],
                          [0, 179],
                          [-179, 0],
                        ],
                        c: true,
                      },
                    ],
                  },
                  {
                    i: { x: 0.62, y: 1 },
                    o: { x: 0.85, y: 0 },
                    t: 25.84,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                        ],
                        v: [
                          [-2, -180.234],
                          [74.744, -47.309],
                          [151.489, 85.617],
                          [-155.489, 85.617],
                        ],
                        c: true,
                      },
                    ],
                  },
                  {
                    i: { x: 0.62, y: 1 },
                    o: { x: 0.85, y: 0 },
                    t: 37,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                        ],
                        v: [
                          [-2, -180.234],
                          [74.744, -47.309],
                          [151.489, 85.617],
                          [-155.489, 85.617],
                        ],
                        c: true,
                      },
                    ],
                  },
                  {
                    i: { x: 0.62, y: 1 },
                    o: { x: 0.167, y: 0 },
                    t: 68,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                        ],
                        v: [
                          [125, -130],
                          [125, 122],
                          [-127, 122],
                          [-127, -130],
                        ],
                        c: true,
                      },
                    ],
                  },
                  {
                    i: { x: 0.62, y: 1 },
                    o: { x: 0.85, y: 0 },
                    t: 81,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                        ],
                        v: [
                          [125, -130],
                          [125, 122],
                          [-127, 122],
                          [-127, -130],
                        ],
                        c: true,
                      },
                    ],
                  },
                  {
                    i: { x: 0.62, y: 1 },
                    o: { x: 0.85, y: 0 },
                    t: 104,
                    s: [
                      {
                        i: [
                          [-98.859, 0],
                          [0, -98.859],
                          [98.859, 0],
                          [0, 98.859],
                        ],
                        o: [
                          [98.859, 0],
                          [0, 98.859],
                          [-98.859, 0],
                          [0, -98.859],
                        ],
                        v: [
                          [0, -179],
                          [179, 0],
                          [0, 179],
                          [-179, 0],
                        ],
                        c: true,
                      },
                    ],
                  },
                  {
                    t: 112,
                    s: [
                      {
                        i: [
                          [-98.859, 0],
                          [0, -98.859],
                          [98.859, 0],
                          [0, 98.859],
                        ],
                        o: [
                          [98.859, 0],
                          [0, 98.859],
                          [-98.859, 0],
                          [0, -98.859],
                        ],
                        v: [
                          [0, -179],
                          [179, 0],
                          [0, 179],
                          [-179, 0],
                        ],
                        c: true,
                      },
                    ],
                  },
                ],
                ix: 2,
              },
              nm: "Tracé 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Traccia 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: {
                a: 1,
                k: [
                  {
                    i: { x: [0.833], y: [0.833] },
                    o: { x: [0.167], y: [0.167] },
                    t: 0,
                    s: [70],
                  },
                  {
                    i: { x: [0.833], y: [0.833] },
                    o: { x: [0.167], y: [0.167] },
                    t: 26,
                    s: [100],
                  },
                  {
                    i: { x: [0.833], y: [0.833] },
                    o: { x: [0.167], y: [0.167] },
                    t: 37,
                    s: [100],
                  },
                  {
                    i: { x: [0.833], y: [0.833] },
                    o: { x: [0.167], y: [0.167] },
                    t: 68,
                    s: [80],
                  },
                  {
                    i: { x: [0.833], y: [0.833] },
                    o: { x: [0.167], y: [0.167] },
                    t: 81,
                    s: [80],
                  },
                  { t: 104, s: [70] },
                ],
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: "Riempimento 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [2, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transformer ",
            },
          ],
          nm: "Ellisse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
      ],
      ip: 0,
      op: 750,
      st: 0,
      bm: 0,
    },
  ],
  markers: [],
};

export default animation;
